import { useState } from 'react';
import { CheckCircle2, XCircle, Circle } from 'lucide-react';
import { GREEN_FLAGS, RED_FLAGS } from '../data/content';
import { Card, SectionLabel } from '../components/UI';

function FlagItem({ title, tip, type }) {
  const [checked, setChecked] = useState(false);
  const isGreen = type === 'green';
  const color = isGreen ? 'var(--accent)' : 'var(--red)';
  const dimColor = isGreen ? 'var(--accent-dim)' : 'var(--red-dim)';

  return (
    <div
      onClick={() => setChecked(c => !c)}
      style={{
        display: 'flex', alignItems: 'flex-start', gap: 12,
        padding: '12px 14px', borderRadius: 'var(--radius)',
        background: checked ? dimColor : 'transparent',
        border: `1px solid ${checked ? color : 'var(--border)'}`,
        cursor: 'pointer', transition: 'all 0.15s', marginBottom: 8,
      }}
    >
      <div style={{ marginTop: 1, flexShrink: 0 }}>
        {checked
          ? isGreen ? <CheckCircle2 size={18} color="var(--accent)" /> : <XCircle size={18} color="var(--red)" />
          : <Circle size={18} color="var(--text3)" />
        }
      </div>
      <div>
        <div style={{ fontSize: 14, fontWeight: 500, color: checked ? color : 'var(--text)', transition: 'color 0.15s' }}>{title}</div>
        <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 3, lineHeight: 1.5 }}>{tip}</div>
      </div>
    </div>
  );
}

export default function QualifyPage() {
  const [reset, setReset] = useState(0);

  return (
    <div>
      <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        <div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 28, fontWeight: 800, letterSpacing: '-0.03em', marginBottom: 6 }}>Qualify Fast</h1>
          <p style={{ color: 'var(--text2)', fontSize: 14 }}>Run each project through this checklist in 60 seconds. Skip red flags immediately.</p>
        </div>
        <button onClick={() => setReset(r => r + 1)} style={{
          fontSize: 12, padding: '7px 14px', background: 'transparent',
          border: '1px solid var(--border2)', borderRadius: 'var(--radius)',
          color: 'var(--text2)', cursor: 'pointer', fontFamily: 'var(--font-mono)',
        }}>Reset</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: 16 }}>
        <div>
          <SectionLabel>Green flags — pitch these</SectionLabel>
          <Card>
            <div style={{ fontSize: 12, color: 'var(--accent)', fontFamily: 'var(--font-mono)', marginBottom: 14 }}>
              Check all that apply ↓
            </div>
            {GREEN_FLAGS.map((f, i) => <FlagItem key={`g-${reset}-${i}`} {...f} type="green" />)}
          </Card>
        </div>

        <div>
          <SectionLabel>Red flags — skip or be cautious</SectionLabel>
          <Card>
            <div style={{ fontSize: 12, color: 'var(--red)', fontFamily: 'var(--font-mono)', marginBottom: 14 }}>
              Any of these = walk away ↓
            </div>
            {RED_FLAGS.map((f, i) => <FlagItem key={`r-${reset}-${i}`} {...f} type="red" />)}
          </Card>
        </div>
      </div>

      <div style={{ marginTop: 16 }}>
        <Card style={{ background: 'var(--amber-dim)', border: '1px solid var(--amber)' }}>
          <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <div style={{ fontSize: 20 }}>⚡</div>
            <div>
              <div style={{ fontWeight: 600, fontSize: 14, color: 'var(--amber)', marginBottom: 4 }}>Golden rule for tonight</div>
              <div style={{ fontSize: 13, color: 'var(--text2)', lineHeight: 1.6 }}>
                If a project passes 3+ green flags and 0 red flags — pitch immediately. Don't overthink it.
                Your goal is 20 pitches tonight, not 5 perfect ones.
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
